<template>
  <div class="card-container" style="padding: 20px; padding-left: 30px">
    <FormItemDescription
      :label="displayData.comment.label"
      :required="displayData.comment.required"
      prop="comment"
    >
      <template #description>
        <p v-if="displayData.comment.description" class="text-gray-80 text-sm">
          {{ displayData.comment.description }}
        </p>
      </template>
      <BaseElInput
        v-model="context.comment"
        type="textarea"
        show-word-limit
        maxlength="150"
        :autosize="{ minRows: 5, maxRows: 6}"
        :placeholder="displayData.comment.placeholder"
      />
    </FormItemDescription>
    <BaseElFormItem :label="displayData.shopNote.label">
      <BaseElInput
        v-model="context.shopNote"
        type="textarea"
        show-word-limit
        maxlength="150"
        :autosize="{ minRows: 5, maxRows: 6}"
        :placeholder="displayData.shopNote.placeholder"
      />
    </BaseElFormItem>
  </div>
</template>

<script>
import { useCreateAppointment } from '@/use/useCreateAppointment'
import { computed, defineComponent } from 'vue'
import { i18n } from '@/plugins/i18n/i18n'
import { get } from 'lodash'
import FormItemDescription from '@/components/FormItem/FormItemDescription.vue'

const DEFAULT_USER_COMMENT_PLACEHOLDER = '請輸入備註'

export default defineComponent({
  name: 'AppointmentOtherInfoBlock',
  components: {
    FormItemDescription,
  },
  setup () {
    const { context, configData } = useCreateAppointment()
    const displayData = computed(() => {
      const userCommentSetting = get(configData, 'reservation.userCommentSetting', {})

      return {
        comment: {
          label: i18n.t('editReservationDialog.comment.title'),
          description: get(userCommentSetting, 'userCommentHint', ''),
          placeholder: get(userCommentSetting, 'userCommentPlaceholder', DEFAULT_USER_COMMENT_PLACEHOLDER),
          required: get(userCommentSetting, 'userCommentRequired', false),
        },
        shopNote: {
          label: i18n.t('editReservationDialog.remark.title'),
          placeholder: i18n.t('editReservationDialog.remark.placeholder'),
        },
      }
    })
    return { displayData, context }
  },
})
</script>

<style lang="postcss" scoped>

</style>
